export default "__VITE_ASSET__Bxzm8OkA__"